// Keep aligned with UploadFileRequest in file-upload-service.
const CHAT_ATTACHMENT_TYPES = [
  'image/jpeg',
  'image/png',
  'application/pdf',
  'video/mp4',
  'video/webm',
  'video/quicktime'
]

export const CHAT_ATTACHMENT_ACCEPT = CHAT_ATTACHMENT_TYPES.join(',')

export const isChatAttachment = (file: Pick<File, 'type'>): boolean => CHAT_ATTACHMENT_TYPES.includes(file.type)
